import { request } from './index';

export type VoiceType = {
  id: number;
  name: string;
  file: string;
};

export async function fetchVoices({
  queryKey: [_, examId]
}: {
  queryKey: [string, number];
}): Promise<VoiceType[]> {
  return await request(true, { url: `exams/voices/e-${examId}` });
}
